import { render, staticRenderFns } from "./GrupoSeparacao.vue?vue&type=template&id=01ca0a09"
import script from "./GrupoSeparacao.vue?vue&type=script&lang=js"
export * from "./GrupoSeparacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports